import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import OfficialPage from '../OfficialPage';
import { TopNav } from '@common/top-nav/TopNav';
import './CouponGoodsListPage.less';

export default class CouponGoodsListPage extends OfficialPage {
  state = {
    param: {
      coupon_id: '',
      page: 1,
      page_size: 10
    },
    isLoading: false,
    noMore: false,
    goodsList: []
  }

  constructor(props) {
    super(props);
    document.title = '可用商品';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let that = this
    if (options.franchisee) {
      that.setData({
        'param.coupon_id': options.detail,
        'param.sub_app_id': options.franchisee
      })
    } else {
      that.setData({ 'param.coupon_id': options.detail })
    }
    that.getGoodsList()
  }

  getGoodsList = () => {
    var that = this
    if (that.data.noMore || that.data.isLoading) {
      return
    }
    that.setData({ isLoading: true })
    app.sendRequest({
      url: '/index.php?r=appShop/getCouponConditionGoods',
      method: 'post',
      data: that.data.param,
      success: function(res) {
        if (res.status == 0) {
          let newData = {},
            goodsList = that.data.goodsList,
            param = that.data.param
          if (param.page > 1) {
            goodsList = goodsList.concat(res.data)
          } else {
            goodsList = res.data
          }
          if (res.is_more == 0) {
            newData.noMore = true
          }
          param.page = res.current_page + 1
          newData.goodsList = goodsList
          newData.param = param
          newData.isLoading = false
          that.setData(newData)
        } else {
          app.showModal({ content: res.data })
        }
      },
      fail: function(res) {
        that.setData({ isLoading: false })
      }
    })
  }
  turnToGoodsDetail = event => {
    let appId = app.globalData.appId,
      dataset = event.currentTarget.dataset,
      id = dataset.id,
      goodsType = dataset.goodsType,
      group = dataset.group,
      subAppId = dataset.subAppId,
      isSeckill = dataset.isSeckill == 1,
      isSelf = appId === subAppId
    if (group && group == 1) {
      if (isSelf) {
        app.turnToPage('/groupGoodsDetail?detail=' + id)
      } else {
        app.turnToPage(
          '/groupGoodsDetail?detail=' +
          id +
          '&franchisee=' +
          subAppId
        )
      }
      return
    }
    switch (+goodsType) {
      case 0:
      case 1:
        let url = '/goodsDetail?detail=' + id
        if (isSeckill) {
          url += '&goodsType=seckill'
        }
        if (!isSelf) {
          url += '&franchisee=' + subAppId
        }
        app.turnToPage(url)
        break
      case 3:
        if (isSelf) {
          app.turnToPage('/toStoreDetail?detail=' + id)
        } else {
          app.turnToPage(
            '/toStoreDetail?detail=' +
            id +
            '&franchisee=' +
            subAppId
          )
        }
        break
    }
  }

  render() {
    const { goodsList, noMore } = this.state
    return (
      <div className="official-page coupon-goods-list-page">
        <TopNav title="可用商品" />
        <ScrollView
          id="couponGoodsList-wrap"
          scroll-y="true"
          bindscrolltolower={this.getGoodsList}
          lower-threshold="50"
        >
          <div className="couponGoodsList-ul">
            {goodsList.map((goodsItem, goodsIdx) => {
              return (
                <div
                  className="couponGoods-li"
                  key={goodsItem.id}
                  data-id={
                    goodsItem.id
                  }
                  data-goods-type={goodsItem.goods_type}
                  data-group={goodsItem.is_group_buy}
                  data-groupid={goodsItem.group_buy_activity_id}
                  data-sub-app-id={goodsItem.app_id}
                  onClick={this.turnToGoodsDetail}
                  data-is-seckill={goodsItem.is_seckill}
                >
                  <div className="couponGoods-logo">
                    <img src={goodsItem.cover} mode="aspectFill" alt="" />
                  </div>
                  <div className="couponGoods-text">
                    <div className="couponGoods-name">{goodsItem.title}</div>
                    <div className="couponGoods-price">
                      {'¥' + goodsItem.price}
                    </div>
                  </div>
                </div>)
            })}
            {noMore && (<div className="no-more">没有更多了</div>)}
          </div>
        </ScrollView>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/coupon-goods-list-page/CouponGoodsListPage.jsx